<template>
	<div class="company-offer column">
		<div class="header-container full-width offer-header">
			<div class="header-title-box">
				<h1>Poznaj naszą ofertę</h1>
			</div>
		</div>
		<div class="offer-container column">
			<div
				class="offer-box"
				v-for="(offer, index) in offerList"
				:key="index"
			>
				<div class="offer-icon">
					<img :src="offer.icon" :alt="offer.title" />
				</div>
				<div class="offer-title">
					<h2>{{ offer.title }}</h2>
				</div>
				<div class="offer-content">
					<ul class="offer-list">
						<li
							v-for="(item, index) in offer.content"
							:key="index"
							class="offer-item"
						>
							{{ item }}
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { offerData } from '../shared/offer-provider'
export default {
	computed: {
		offerList: function() {
			return offerData
		},
	},
	metaInfo: {
		title:
			'Oferta - Obsługa księgowa Sulechów - Biuro Rachunkowe Joanna Macikowska',
		meta: [
			{
				itemprop: 'name',
				content:
					'Oferta - Obsługa księgowa Sulechów - Biuro Rachunkowe Joanna Macikowska',
			},
			{
				itemprop: 'description',
				content:
					'Sulechów Biuro Rachunkowe - Kontakt: tel. 690 00 11 53. Usługi ksiegowa dla firm',
			},
			{
				itemprop: 'image',
				content: 'https://macikowska.pl/site_img.jpeg',
			},
			{
				property: 'og:title',
				content: 'Oferta - Biuro Rachunkowe Joanna Macikowska',
			},
			{ property: 'og:site_name', content: 'macikowska.pl' },
			// The list of types is available here: http://ogp.me/#types
			{ property: 'og:type', content: 'website' },
			// Should the the same as your canonical link, see below.
			{
				property: 'og:url',
				content: 'https://macikowska.pl/oferta',
			},
			{
				property: 'og:image',
				content: 'https://macikowska.pl/site_img.jpeg',
			},
			// Often the same as your meta description, but not always.
			{
				property: 'og:description',
				content:
					'Obłsuga księgowa firm na najwyższym poziomie. Sprawdź naszą ofertę',
			},
		],
	},
}
</script>

<style lang="scss">
@include media-breakpoint-up(xs) {
	.offer-header {
		@include standard-header;
	}
	.offer-container {
		padding: 1em 0;
	}
	.offer-box {
		border-radius: 5px;
		padding: 1em;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
		margin: 0 1em;
		margin-bottom: 1em;
		font-size: 1em;
	}
	.offer-icon {
		text-align: center;
		& > img {
			width: 3em;
			height: auto;
		}
	}
}
@include media-breakpoint-up(sm) {
}
@include media-breakpoint-up(md) {
}
@include media-breakpoint-up(lg) {
	.offer-container {
		padding: 2em;
	}
	.offer-box {
		border-radius: 5px;
		padding: 4em;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
		margin: 0 auto;
		margin-bottom: 2em;
		font-size: 1.3em;
		max-width: 65%;
		min-width: 65%;
	}
}
@include media-breakpoint-up(xl) {
}
</style>
